import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { MessageCircle } from 'lucide-react';
import { chatApi } from '@/entities/message';
import { QUERY_KEYS } from '@/shared/config/constants';
import { SearchInput, Skeleton } from '@/shared/ui';
import { ConversationItem } from './ConversationItem';

export const ChatListPage = () => {
  const [search, setSearch] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: QUERY_KEYS.CONVERSATIONS,
    queryFn: chatApi.listConversations,
    staleTime: 60 * 1000,
  });

  const conversations = (data?.conversations ?? []).filter((c) =>
    c.participanteNome.toLowerCase().includes(search.trim().toLowerCase()),
  );

  return (
    <section className="mx-auto flex w-full max-w-3xl flex-col gap-6">
      <header className="flex flex-col gap-1.5">
        <h1 className="text-3xl font-semibold tracking-tight text-gray-900">Conversas</h1>
        <p className="text-sm text-gray-500">Continue de onde parou com seus matches.</p>
      </header>

      <SearchInput
        value={search}
        onChange={setSearch}
        placeholder="Buscar conversa"
      />

      {isLoading ? (
        <ul aria-busy="true" aria-label="Carregando conversas" className="flex flex-col gap-2">
          {Array.from({ length: 6 }).map((_, idx) => (
            <li
              key={idx}
              className="flex items-center gap-3 rounded-2xl bg-white px-4 py-3.5"
            >
              <Skeleton className="size-12 shrink-0 rounded-full" />
              <div className="flex min-w-0 flex-1 flex-col gap-2">
                <Skeleton className="h-4 w-3/5" />
                <Skeleton className="h-3 w-11/12" />
              </div>
              <Skeleton className="h-3 w-10 shrink-0" />
            </li>
          ))}
        </ul>
      ) : conversations.length === 0 ? (
        <div className="mt-12 flex flex-col items-center justify-center text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gray-50">
            <MessageCircle className="h-7 w-7 text-gray-300" aria-hidden />
          </div>
          <p className="mt-4 text-base font-semibold text-gray-700">Nenhuma conversa ainda</p>
          <p className="mt-1 max-w-[280px] text-sm text-gray-500">
            Suas conversas com matches aparecerão aqui assim que vocês começarem a trocar mensagens.
          </p>
        </div>
      ) : (
        <ul role="list" className="flex flex-col gap-2">
          {conversations.map((c) => (
            <ConversationItem key={c.matchId} conversation={c} />
          ))}
        </ul>
      )}
    </section>
  );
};
